"use strict";

/**
 * @see - https://developers.google.com/recaptcha/docs/v3
 * @param variables {{ recaptcha: {siteKey: string} }}
 */
const ngRecaptcha = ['$lazyScripts', ($lazyScripts) => {
    return {
        scope: {
            formId: '@ngRecaptcha',
            onCaptchaComplete: '&?',
        },
        async link(scope, element) {
            const rawElement = element[0];

            const container = document.createElement('div');
            container.className = 'recaptcha-container';
            container.style.display = 'none';
            rawElement.parentElement.appendChild(container);

            const callback = scope.onCaptchaComplete ? token => scope.onCaptchaComplete({token}) : () => {
                const form = scope.formId ? document.getElementById(scope.formId) : rawElement.closest('form');
                form.submit();
            };

            const recaptcha = await $lazyScripts.loadRecaptcha();
            const widgetId = recaptcha.render(container, {
                sitekey: window.variables.recaptcha.siteKey,
                size: 'invisible',
                callback,
            }, true);

            rawElement.addEventListener('click', e => {
                e.preventDefault();
                recaptcha.reset(widgetId);
                recaptcha.execute(widgetId);
            });
        }
    }
}];
export default ngRecaptcha;
